"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initRudderStack = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _nucleusLogging = require("@cvent/nucleus-logging");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } /**
 * ------------------------------------------------------------------------------------
 * This client was automatically generated. ** Do Not Edit **
 * ------------------------------------------------------------------------------------
 */
var getWindow = function getWindow() {
  return window;
};
var RUDDER_STACK_LOADED = false;
var LOG = new _nucleusLogging.Logger('RudderStackLogger');
/**
 * Gets the latest RS SDK v3.0 as of Sept 25th 2023.
 * RS Docs: https://www.rudderstack.com/docs/sources/event-streams/sdks/rudderstack-javascript-sdk/v3/
 *
 * TLDR;
 *  - Smaller SDK
 *  - Improves cookie storage
 *  - Ability to choose the required SDK features via plugins
 *  - Lightweight storage data by switching to base64 encryption
 *
 * @param config
 * @param writeKey
 * @param dataPlaneUrl
 * @returns
 */
var initRudderStack = exports.initRudderStack = /*#__PURE__*/function () {
  var _ref2 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(_ref) {
    var metricsEnabled, writeKey, dataPlaneUrl, _ref$config, config, environmentName, _ref$onLoaded, onLoaded, logLevel, loadConfig, _require, RudderAnalytics, rudderanalytics, params;
    return _regenerator["default"].wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          metricsEnabled = _ref.metricsEnabled, writeKey = _ref.writeKey, dataPlaneUrl = _ref.dataPlaneUrl, _ref$config = _ref.config, config = _ref$config === void 0 ? {} : _ref$config, environmentName = _ref.environmentName, _ref$onLoaded = _ref.onLoaded, onLoaded = _ref$onLoaded === void 0 ? function (instance) {
            return instance;
          } : _ref$onLoaded;
          if (!(typeof window === 'undefined')) {
            _context.next = 1;
            break;
          }
          return _context.abrupt("return");
        case 1:
          try {
            if (!RUDDER_STACK_LOADED) {
              if (metricsEnabled && writeKey && dataPlaneUrl) {
                logLevel = environmentName === 'dev' ? 'DEBUG' : null;
                loadConfig = _objectSpread(_objectSpread({}, config), {}, {
                  logLevel: logLevel
                });
                _require = require('@rudderstack/analytics-js/bundled'), RudderAnalytics = _require.RudderAnalytics;
                rudderanalytics = new RudderAnalytics(); // Load options docs: https://www.rudderstack.com/docs/sources/event-streams/sdks/rudderstack-javascript-sdk/load-js-sdk/#loading-options
                rudderanalytics.load(writeKey, dataPlaneUrl, _objectSpread({
                  integrations: {
                    All: true
                  },
                  /**
                   * Plugins docs:
                   * v3.0     => https://www.rudderstack.com/docs/sources/event-streams/sdks/rudderstack-javascript-sdk/v3/#load-options
                   * previous => https://www.rudderstack.com/docs/sources/event-streams/sdks/rudderstack-javascript-sdk/v3/#plugins
                   */
                  plugins: ['BeaconQueue', 'StorageEncryption', 'StorageMigrator', 'XhrQueue'],
                  storage: {
                    encryption: {
                      // Switch over to base64 encryption
                      version: 'v3'
                    },
                    /**
                     * We are not implementing groupTraits so we specify their type to none so the Rudderstack SDK deletes them from the user's device
                     * Storage docs: https://www.rudderstack.com/docs/sources/event-streams/sdks/rudderstack-javascript-sdk/v3/cookieless-tracking/#set-storage-for-specific-information-type
                     */
                    entries: {
                      groupId: {
                        type: 'none'
                      },
                      groupTraits: {
                        type: 'none'
                      }
                    },
                    migrate: true
                  }
                }, loadConfig));
                getWindow().rudderanalytics = rudderanalytics;
                rudderanalytics.ready(function () {
                  onLoaded(rudderanalytics);
                });
                RUDDER_STACK_LOADED = true;
              } else {
                params = JSON.stringify({
                  metricsEnabled: metricsEnabled,
                  writeKey: writeKey,
                  dataPlaneUrl: dataPlaneUrl
                });
                LOG.debug("Failed initializing rudderstack instance >>>> ".concat(params));
              }
            }
          } catch (error) {
            LOG.debug('Failed importing the rudderstack SDK. Make sure you have it as a dependency in your package.json', error);
          }
        case 2:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function initRudderStack(_x) {
    return _ref2.apply(this, arguments);
  };
}();